"use strict";
"use client";

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _createForOfIteratorHelper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/useSuspenseQueries.ts


var useSuspenseQueries_exports = {};

__export(useSuspenseQueries_exports, {
  useSuspenseQueries: function useSuspenseQueries() {
    return _useSuspenseQueries;
  }
});

module.exports = __toCommonJS(useSuspenseQueries_exports);

var import_query_core = require("@tanstack/query-core");

var import_useQueries = require("./useQueries.cjs");

var import_suspense = require("./suspense.cjs");

function _useSuspenseQueries(options, queryClient) {
  return (0, import_useQueries.useQueries)(_objectSpread(_objectSpread({}, options), {}, {
    queries: options.queries.map(function (query) {
      if (process.env.NODE_ENV !== "production") {
        if (query.queryFn === import_query_core.skipToken) {
          console.error("skipToken is not allowed for useSuspenseQueries");
        }
      }

      return _objectSpread(_objectSpread({}, query), {}, {
        suspense: true,
        throwOnError: import_suspense.defaultThrowOnError,
        enabled: true,
        placeholderData: void 0
      });
    })
  }), queryClient);
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  useSuspenseQueries: _useSuspenseQueries
});